// Logo component: renders the AI-generated PNG logo saved at /public/logo.png.
export default function Logo({ size = 40, className = "", testId = "logo" }) {
  return (
    <span className={`inline-flex items-center ${className}`} data-testid={testId}>
      <img
        src="/logo.png"
        alt="iCrack Solutions"
        style={{ height: `${size}px`, width: "auto", objectFit: "contain" }}
        loading="eager"
      />
    </span>
  );
}
